// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_bz-0";
export var headerCellHover = "_bz-1";